import { render } from "./ReviewEditor.vue?vue&type=template&id=213e5592&ts=true"
import script from "./ReviewEditor.vue?vue&type=script&lang=ts"
export * from "./ReviewEditor.vue?vue&type=script&lang=ts"

import "./ReviewEditor.vue?vue&type=style&index=0&id=213e5592&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__